<template>
    <router-link :to="{name: 'campaign.show', params:{slug: slug}}">
        <div class="bg-white rounded-xl shadow-md my-4 mx-2">
            <div class="rounded-xl md:p-0">
                <img class="h-36 w-64 rounded-tl-xl rounded-tr-xl object-cover" :src="image">
                <div class=" w-64 pt-2 md:pt-5 p-4 md:p-3 text-left space-y-2">
                    <p class="text-sm font-semibold title">{{ title }}</p>
                    <div v-if="sumDonation.length > 0">
                        <div v-for="donation in sumDonation" :key="donation">

                            <p class="text-xs text-gray-500 mb-3">
                                <span class="font-bold text-yellow-600">Rp. {{ formatPrice(donation.total) }} </span>
                                terkumpul
                            </p>
                            <div v-if="typeCampaign == campaignType.QURBAN_KAMBING || typeCampaign == campaignType.QURBAN_SAPI || typeCampaign == campaignType.QURBAN_PATUNGAN">
                                <div class="mt-3 text-xs">
                                    <strong>{{ countDay(maxDate) }}</strong> hari lagi
                                </div>
                            </div>
                            <div v-else class="relative">
                                <div class="overflow-hidden h-1 mb-1 text-xs flex rounded bg-yellow-200">
                                    <div :style="{width: percentage(donation.total, targetDonation) + '%'}"
                                        class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-yellow-500">
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div v-else>

                        <p class="text-xs text-gray-500 mb-3">
                            <span class="font-bold text-yellow-500">Rp. 0 </span> terkumpul
                        </p>
                        <div v-if="typeCampaign == campaignType.QURBAN_KAMBING || typeCampaign == campaignType.QURBAN_SAPI || typeCampaign == campaignType.QURBAN_PATUNGAN">
                            <div class="-mt-2 text-xs">
                                <strong>{{ countDay(maxDate) }}</strong> hari lagi
                            </div>
                        </div>
                        <div v-else class="relative">
                            <div class="overflow-hidden h-1 mb-1 text-xs flex rounded bg-yellow-300">
                                <div :style="{width: percentage(0, targetDonation) + '%'}"
                                    class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-yellow-500">
                                </div>
                            </div>
                        </div>

                    </div>
                    <!-- <div class="mt-1 text-xs">
						<strong>{{ countDay(maxDate) }}</strong> hari lagi
					</div> -->
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
    import CampaignTypeEnum from '@/enums/CampaignTypeEnum.js'

    export default {
        props: {
            image: String,
            title: String,
            slug: String,
            sumDonation: Array,
            targetDonation: String,
            maxDate: String,
            typeCampaign: String
        },
        setup() {
            const campaignType = CampaignTypeEnum

            return {
                campaignType
            }
        }
    }
</script>

<style>
    .title {
        word-break: break-word;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        line-height: 16px;
        /* fallback */
        max-height: 32px;
        /* fallback */
        -webkit-line-clamp: 1;
        /* number of lines to show */
        -webkit-box-orient: vertical;
    }
</style>